/**
 * @module resolve
 * @since 1.0.0
 */

import { glob } from '../../environment';

/**
 * Resolve object with a dot notation string.
 *
 * @param  {String} string    A string notation of an object, separated by dots.
 * @param  {Object} [context] Object to start notation search (defaults to global scope).
 * @return {*}
 *
 * @example
 * const data_object = {
 *   top_level: {
 *     nested: {
 *       value: 'My Value'
 *     }
 *   }
 * };
 *
 * resolve('top_level.nested.value', data_object);
 * // 'My Value'
 *
 * resolve('top_level.missing.value', data_object);
 * // undefined
 */
export const resolve = (string = '', context = glob) => string
    .split('.')
    .reduce((previous, current) => typeof previous === 'object' ? previous[current] : previous, context);
